export const placeholderFile = 'placeholder_file';
